

export const frontMatter = {};
export const contentTitle = 'BrushingExtension';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-extensions-brushing-extension-md-f3f.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Installation",
  "id": "installation",
  "level": 2
}, {
  "value": "Constructor",
  "id": "constructor",
  "level": 2
}, {
  "value": "Layer Properties",
  "id": "layer-properties",
  "level": 2
}, {
  "value": "<code>brushingRadius</code> (number)",
  "id": "brushingradius",
  "level": 4
}, {
  "value": "<code>brushingEnabled</code> (boolean, optional)",
  "id": "brushingenabled",
  "level": 4
}, {
  "value": "<code>brushingTarget</code> (string, optional)",
  "id": "brushingtarget",
  "level": 4
}, {
  "value": "<code>getBrushingTarget</code> (Accessor&lt;Position&gt;, optional)",
  "id": "getbrushingtarget",
  "level": 4
}, {
  "value": "Source",
  "id": "source",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "brushingextension",
        children: "BrushingExtension"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "BrushingExtension"
      }), " adds GPU-based data brushing functionalities to layers. It allows the layer to show/hide objects based on the current pointer position."]
    }), "\n", _jsx("div", {
      style: {
        position: 'relative',
        height: 450
      }
    }), "\n", _jsx("div", {
      style: {
        position: 'absolute',
        transform: 'translateY(-450px)',
        paddingLeft: 'inherit',
        paddingRight: 'inherit',
        left: 0,
        right: 0
      },
      children: _jsx("iframe", {
        height: "450",
        style: {
          width: '100%'
        },
        scrolling: "no",
        title: "deck.gl BrushingExtension",
        src: "https://codepen.io/vis-gl/embed/NWbxdKP?height=450&theme-id=light&default-tab=result",
        frameborder: "no",
        loading: "lazy",
        allowtransparency: "true",
        allowfullscreen: "true",
        children: _jsxs(_components.p, {
          children: ["See the Pen ", _jsx("a", {
            href: "https://codepen.io/vis-gl/pen/NWbxdKP",
            children: "deck.gl BrushingExtension"
          }), " by vis.gl\n(", _jsx("a", {
            href: "https://codepen.io/vis-gl",
            children: "@vis-gl"
          }), ") on ", _jsx("a", {
            href: "https://codepen.io",
            children: "CodePen"
          }), "."]
        })
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import {ScatterplotLayer} from '@deck.gl/layers';\nimport {BrushingExtension} from '@deck.gl/extensions';\n\nconst layer = new ScatterplotLayer({\n  id: 'points',\n  data: POINTS,\n\n  // props from ScatterplotLayer\n  getPosition: d => d.position,\n  getRadius: d => d.radius,\n\n  // props added by BrushingExtension\n  brushingEnabled: true,\n  brushingRadius: 100000,\n\n  // Define extensions\n  extensions: [new BrushingExtension()]\n});\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "installation",
      children: "Installation"
    }), "\n", _jsx(_components.p, {
      children: "To install the dependencies from NPM:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-bash",
        children: "npm install deck.gl\n# or\nnpm install @deck.gl/core @deck.gl/layers @deck.gl/extensions\n"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import {BrushingExtension} from '@deck.gl/extensions';\nnew BrushingExtension();\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "To use pre-bundled scripts:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-html",
        children: "<script src=\"https://unpkg.com/deck.gl@^9.0.0/dist.min.js\"></script>\n<!-- or -->\n<script src=\"https://unpkg.com/@deck.gl/core@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/layers@^9.0.0/dist.min.js\"></script>\n<script src=\"https://unpkg.com/@deck.gl/extensions@^9.0.0/dist.min.js\"></script>\n"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "new deck.BrushingExtension();\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "constructor",
      children: "Constructor"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "new BrushingExtension();\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "layer-properties",
      children: "Layer Properties"
    }), "\n", _jsxs(_components.p, {
      children: ["When added to a layer via the ", _jsx(_components.code, {
        children: "extensions"
      }), " prop, the ", _jsx(_components.code, {
        children: "BrushingExtension"
      }), " adds the following properties to the layer:"]
    }), "\n", _jsxs(_components.h4, {
      id: "brushingradius",
      children: [_jsx(_components.code, {
        children: "brushingRadius"
      }), " (number)"]
    }), "\n", _jsx(_components.p, {
      children: "The brushing radius centered at the pointer, in meters. If a data object is within this circle, it is rendered; otherwise it is hidden."
    }), "\n", _jsxs(_components.h4, {
      id: "brushingenabled",
      children: [_jsx(_components.code, {
        children: "brushingEnabled"
      }), " (boolean, optional)"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Default: ", _jsx(_components.code, {
          children: "true"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Enable/disable brushing. If brushing is disabled, all objects are rendered."
    }), "\n", _jsx(_components.p, {
      children: "Brushing is always disabled when the pointer leaves the current viewport."
    }), "\n", _jsxs(_components.h4, {
      id: "brushingtarget",
      children: [_jsx(_components.code, {
        children: "brushingTarget"
      }), " (string, optional)"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Default: ", _jsx(_components.code, {
          children: "source"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "The position used to filter each object by. One of the following:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "'source'"
        }), ": Use the primary position for each object. This can mean different things depending on the layer. It usually refers to the coordinates returned by ", _jsx(_components.code, {
          children: "getPosition"
        }), " or ", _jsx(_components.code, {
          children: "getSourcePosition"
        }), " accessors."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "'target'"
        }), ": Use the secondary position for each object. This may not be available in some layers. It usually refers to the coordinates returned by ", _jsx(_components.code, {
          children: "getTargetPosition"
        }), " accessors."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "'source_target'"
        }), ": Use both the primary position and secondary position for each object. Show objet if either is in brushing range."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "'custom'"
        }), ": Some layers may not describe their data objects with one or two coordinates, for example ", _jsx(_components.code, {
          children: "PathLayer"
        }), " and ", _jsx(_components.code, {
          children: "PolygonLayer"
        }), ". Use this option with the ", _jsx(_components.code, {
          children: "getBrushingTarget"
        }), " prop to provide a custom position that each object should be filtered by."]
      }), "\n"]
    }), "\n", _jsxs(_components.h4, {
      id: "getbrushingtarget",
      children: [_jsx(_components.code, {
        children: "getBrushingTarget"
      }), " (", _jsx(_components.a, {
        href: "/docs/developer-guide/using-layers#accessors",
        children: "Accessor<Position>"
      }), ", optional)"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Default: ", _jsx(_components.code, {
          children: "null"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Called to retrieve an arbitrary position for each object that it will be filtered by. Returns an array ", _jsx(_components.code, {
        children: "[x, y]"
      }), ". Only effective if ", _jsx(_components.code, {
        children: "brushingTarget"
      }), " is set to ", _jsx(_components.code, {
        children: "custom"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "source",
      children: "Source"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://github.com/visgl/deck.gl/tree/9.4-release/modules/extensions/src/brushing",
        children: "modules/extensions/src/brushing"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

